import z from "zod";
import {
  templateFormBaseSchema,
  templatePatientTypeSchema,
  templateScheduleSchema,
} from "../TemplateForm/templateFormSchema";
import { weekdaySchema } from "@/api/Activities";

export const batchTemplateActivityInclusionTypeSchema = z.enum([
  "optional",
  "optionalWithDefaultSelected",
]);

export const batchTemplateActivityDelayedStartDateOptionsSchema = z.enum([
  "none",
  "offset",
  "weekday",
  "userSelects",
]);
export type IBatchTemplateActivityDelayedStartDateOption =
  (typeof batchTemplateActivityDelayedStartDateOptionsSchema.enum)[keyof typeof batchTemplateActivityDelayedStartDateOptionsSchema.enum];

export const batchTemplateActivityDelayedStartDateUnitSchema = z.enum([
  "week",
  "day",
]);

export const batchTemplateActivityTimeConfigTypeSchema = z.enum([
  "shared",
  "individual",
]);
export type IBatchTemplateActivityTimeConfigType =
  (typeof batchTemplateActivityTimeConfigTypeSchema.enum)[keyof typeof batchTemplateActivityTimeConfigTypeSchema.enum];

export const batchTemplateActivityFormSchema = templateFormBaseSchema.extend({
  timeConfigType: batchTemplateActivityTimeConfigTypeSchema,
  inclusionType: batchTemplateActivityInclusionTypeSchema,
  delayedStartDate: batchTemplateActivityDelayedStartDateOptionsSchema,
  delayedStartDateOffset: z.string().nullish(),
  delayedStartDateUnit:
    batchTemplateActivityDelayedStartDateUnitSchema.nullish(),
  delayedStartDateWeekday: weekdaySchema.nullish(),
});

const batchTemplateActivitySchema = z
  .object({
    id: z.uuid(),
  })
  .extend(batchTemplateActivityFormSchema.shape);

export const batchTemplateFormSchema = z
  .object({
    title: z.string(),
    activities: z.array(batchTemplateActivitySchema),
    sharedTimeConfig: templateScheduleSchema.nullish(),
  })
  .extend(templatePatientTypeSchema.shape);

export type BatchTemplateActivityFormFields = z.infer<
  typeof batchTemplateActivityFormSchema
>;

export type IBatchTemplateActivity = z.infer<
  typeof batchTemplateActivitySchema
>;

export type BatchTemplateFormFields = z.infer<typeof batchTemplateFormSchema>;
